<template>
    <div class="JWvideoHandler">

        <div v-bind:id='playerID' :ref = "playerID">
            Loading video...
        </div>
        <transition name="fade" v-if="showButtonFlag">
        <button @click="redirectUserToJoin" id="buyflow" class="pink-button" v-if="showButtonFlag" :style="{'border-width': '1px !important', 'border-style': 'solid !important', 'border-color': this.getCorpButtonColor + ' !important', 'color': $a11yTextColor(this.getCorpButtonColor) + ' !important', 'background-color': this.getCorpButtonColor + ' !important' }">Join Now</button>
    </transition>
        <transition name="fade" v-if="becomeMemberFlag">
            <button @click="redirectUserToCompleteSignup" id="becomeMemberflow" class="pink-button" v-if="becomeMemberFlag">Update my Membership</button>
        </transition>
    </div>
</template>

<script>
    import store from '../store'
    import { mapGetters } from 'vuex'
    import { dateHelpers } from '../helpers/dateHelpers.js'
export default {
        props: ['data', 'onComplete'],
        name: 'jwplayer',
        data: function () {
            return {
                playerID: Math.floor(Math.random() * 1000000),
                isMute: false,
                autoStartVideo: true,
                duration: 0,
                directedFromAuthenticatedPage: false,
                repeat: false,
                showButtonFlag: false,
                showNativeFlag: false,
                becomeMemberFlag: false
            }
        },
        methods: {
            redirectUserToJoin () {
                if (navigator.userAgent.indexOf('gonative') > -1) { // Native app
                    this.$router.push('/joinnative')
                } else { // regular user
                    this.$router.push('/signup')
                }
            },
            redirectUserToCompleteSignup () {
                this.$router.push('/becomemember')
            }
        },
        mounted () {
            var self = this
            let userTimeZone = dateHelpers.getUserTimeZone()
            let completeVideoReference = `${userTimeZone} | ${self.currentRoute.name} | ${self.data.mediaId}`
            console.log('video refernce', completeVideoReference)
            if (this.data.repeat) {
                this.repeat = true
            }
            if (this.data.isMute) {
                this.isMute = true
            } else {
                this.isMute = false
            }
            // jwplayer.mute
            if (self.currentRoute.name === 'ArchivePlayer' || self.currentRoute.name === 'TrendingPlaylistVideoPlayer' || self.currentRoute.name === 'CorpPlaylistVideoPlayer' || self.currentRoute.name === 'PlaylistVideoPlayer') {
                if (localStorage.getItem('jwplayer.mute')) {
                    let currentSetting = localStorage.getItem('jwplayer.mute')
                    currentSetting = JSON.parse(currentSetting)
                    console.log('local storage setting', currentSetting)
                    self.isMute = currentSetting
                }
            }
            if (this.data.autoStart === undefined || this.data.autoStart) {
                this.autoStartVideo = true
            } else if (!this.data.autoStart) {
                this.autoStartVideo = false
            } else {
                this.autoStartVideo = true
            }
            let lastPosition = 0
            window.jwplayer(this.$refs[this.playerID]).setup({
            // URL to the video file
                file: this.data.video,
            // URL to the image that should be shown before the video is started
                image: this.data.img,
                title: this.data.title,
                tracks: this.data.tracks,
                mediaid: this.data.mediaid,
                mute: this.isMute,
                repeat: this.repeat,
                stretching: 'uniform',
//                autostart: true,
                width: '100%',
                events: {
                    onSetupError: function (state) {
                        console.log('setup error', state)
                        let errorPayload = {}
                        errorPayload.userId = self.user ? self.user.userId : 0
                        errorPayload.action = 'JW_SETUP_ERROR'
                        errorPayload.activityCode = state.code
                        errorPayload.activityMessage = state.message
                        errorPayload.severityLevel = null
                        errorPayload.status = self.data.mediaId
                        errorPayload.timeZone = dateHelpers.getUserTimeZone()
                        errorPayload.pageName = self.currentRoute.fullPath
                        errorPayload.os = dateHelpers.userPlatForm().os.family
                        errorPayload.osVersion = dateHelpers.userPlatForm().os.version
                        errorPayload.browserName = dateHelpers.userPlatForm().name
                        errorPayload.browserVersion = dateHelpers.userPlatForm().version
                        errorPayload.device = dateHelpers.userPlatForm().product
                        errorPayload.deviceType = null
                        // Additional logging
                        errorPayload.userAgent = navigator.userAgent
                        if (navigator.userAgent.indexOf('gonative') > -1) {
                            // IOS App
                            errorPayload.deviceType = 'IOS APP'
                        } if (navigator.userAgent.indexOf('gonativeand') > -1) {
                            // Andoird App
                            errorPayload.deviceType = 'ANDROID APP'
                        }
                        console.log('log video error activty')
                        self.$store.dispatch('LOGVIDEOERROR', errorPayload)
                    },
                    onError: function (state) {
                        console.log('regular error', state)
                        let errorPayload = {}
                        errorPayload.userId = self.user ? self.user.userId : 0
                        errorPayload.action = 'JW_ERROR'
                        errorPayload.activityCode = state.code
                        errorPayload.activityMessage = state.message
                        errorPayload.severityLevel = null
                        errorPayload.status = self.data.mediaId
                        errorPayload.timeZone = dateHelpers.getUserTimeZone()
                        errorPayload.pageName = self.currentRoute.fullPath
                        errorPayload.os = dateHelpers.userPlatForm().os.family
                        errorPayload.osVersion = dateHelpers.userPlatForm().os.version
                        errorPayload.browserName = dateHelpers.userPlatForm().name
                        errorPayload.browserVersion = dateHelpers.userPlatForm().version
                        errorPayload.device = dateHelpers.userPlatForm().product
                        errorPayload.deviceType = null
                        // Additional logging
                        errorPayload.userAgent = navigator.userAgent
                        if (navigator.userAgent.indexOf('gonative') > -1) {
                            // IOS App
                            errorPayload.deviceType = 'IOS APP'
                        } if (navigator.userAgent.indexOf('gonativeand') > -1) {
                            // Andoird App
                            errorPayload.deviceType = 'ANDROID APP'
                        }
                        self.$store.dispatch('LOGVIDEOERROR', errorPayload)
                    },
                    onReady: function (state) {
                        if (state.type === 'ready') {
                            window['videoPlaying'] = true
//                            this.play(true)
                            if (self.autoStartVideo) {
                                setTimeout(() => {
                                    if (this.$refs && this.$refs[this.playerID]) {
                                        this.$refs[this.playerID].seek(1)
                                        this.$refs[this.playerID].play(true)
                                        if (!self.isMute) {
                                            this.setVolume(30)
                                        }
                                    }
                                }, 200)
//                                this.seek(1)
                            }
                            // this.setCurrentCaptions(0)
                            let errorPayload = {}
                            errorPayload.userId = self.user ? self.user.userId : 0
                            errorPayload.action = 'JW_VIDEO_LOADED'
                            errorPayload.activityCode = self.data.mediaId
                            errorPayload.activityMessage = self.data.mediaId
                            errorPayload.severityLevel = null
                            errorPayload.status = self.data.mediaId
                            errorPayload.timeZone = dateHelpers.getUserTimeZone()
                            errorPayload.pageName = self.currentRoute.fullPath
                            errorPayload.os = dateHelpers.userPlatForm().os.family
                            errorPayload.osVersion = dateHelpers.userPlatForm().os.version
                            errorPayload.browserName = dateHelpers.userPlatForm().name
                            errorPayload.browserVersion = dateHelpers.userPlatForm().version
                            errorPayload.device = dateHelpers.userPlatForm().product
                            errorPayload.deviceType = null
                            // Additional logging
                            errorPayload.userAgent = window.navigator.userAgent
                            if (window.navigator.userAgent.indexOf('gonative') > -1) {
                                // IOS App
                                errorPayload.deviceType = 'IOS APP'
                            } if (window.navigator.userAgent.indexOf('gonativeand') > -1) {
                                // Andoird App
                                errorPayload.deviceType = 'ANDROID APP'
                            }
                            self.$store.dispatch('LOGVIDEOERROR', errorPayload)
//                            if (self.currentRoute.name === 'UnauthPlayer' && (self.currentRoute.fullPath.indexOf('tonetakeaway') > -1) || self.currentRoute.fullPath.indexOf('toneteaser') > -1) {
//                                this.play(false)
//                            }
                        }
                    },
                    onTime: function (state) {
                    // For user last position
                        let currentPosition = Math.floor(this.getPosition())
                        let totalDuration = Math.floor(this.getDuration())
                        // Show buy button before 3 seconds of video
                        if (totalDuration - currentPosition <= 5 && self.user && self.currentRoute.name === 'Player' && self.user.trialEndDate !== null && (self.$route.params.refBy.toLowerCase() === 'toneteaser' || self.$route.params.refBy.toLowerCase() === 'tonetakeaway')) {
                            this.setFullscreen(false)
                            self.becomeMemberFlag = true
                        } else {
                            self.becomeMemberFlag = false
                        }
                        if (totalDuration - currentPosition <= 3 && !self.user && self.currentRoute.name !== 'UnAuth' && self.currentRoute.name !== 'B2b') {
                            this.setFullscreen(false)
                            self.showButtonFlag = true
                        } else {
                            self.showButtonFlag = false
                        }
                        if (currentPosition <= totalDuration && lastPosition !== currentPosition) {
                            // console.log('duration watched', currentPosition)
                            store.commit('setCurrentVideoDurationWatched', {duration: currentPosition})
                        }
                        lastPosition = currentPosition
                    },
                    onComplete: (state) => {
                        this.onComplete()
                        window['videoPlaying'] = false
                    }
                }
            })
        },
        computed: {
            ...mapGetters([
                'user', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor'
            ]),
            currentRoute () {
                //  console.log('route', this.$route)
//            console.log('route', this.$route.name)
//            if (this.$route.name === 'Redeem,') {
//                console.log('yes')
//            }
                return this.$route
            }
        }
}
</script>
<style scoped>
    .JWvideoHandler>button.pink-button {
        position: absolute;
        z-index: 100;
        bottom: 60px;
        left: 50%;
        transform: translateX(-50%);
        color: white;
        font-size: 16px;
        border: none;
        width: 253px;
        padding: 14px 15px 12px;
        border-radius: 3px;
        background: rgb(240, 97, 125) !important;
        text-transform: uppercase !important;
        letter-spacing: 1px !important;
    }

    .JWvideoHandler {
        position: relative;
    }
    .jwplayer.jw-flag-fullscreen+button {
        position: fixed;
        z-index: 999999999999999999;
    }

    @media(max-width:1024px) {
        .JWvideoHandler {
            width: 100%;
            display: table;
        }
    }
    @media(max-width:767px){
        .JWvideoHandler>button.pink-button {
            font-size: 14px;
            border: none;
            width: auto;
            padding: 8px 10px 5px;
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    @media(min-width:1350px){
        .JWvideoHandler>button.pink-button{
            bottom:15%;
        }
    }
</style>



// WEBPACK FOOTER //
// JwPlayer.vue?72d2b332